import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { FirebaseError } from "firebase/app";


// Upload image function
export const uploadImage = async (path: string, file: File) => {
  try {
    const storage = getStorage();
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

// Delete image function
export const deleteImage = async (folder: string, fileName: string) => {
  try {
    const storage = getStorage();
    const imageRef = ref(storage, `${folder}/${fileName}`);
    await deleteObject(imageRef);
  } catch (error) {
    if (error instanceof FirebaseError && error.code === "storage/object-not-found") {
      console.warn("Image not found, skipping deletion");
    } else {
      console.error("Error deleting image:", error);
      throw error;
    }
  }
};

// Retrieve image function
export const retrieveImage = async (folder: string, fileName: string) => {
  try {
    const storage = getStorage();
    const imageRef = ref(storage, `${folder}/${fileName}`);
    const downloadURL = await getDownloadURL(imageRef);
    return downloadURL;
  } catch (error) {
    console.error("Error retrieving image:", error);
    throw error;
  }
};
